import script from "./CameraFeed.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraFeed.vue?vue&type=script&setup=true&lang=js"

import "./CameraFeed.vue?vue&type=style&index=0&id=048abe02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-048abe02"]])

export default __exports__